// @commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');

// @actions
const errorActions = require('actions/brokerError');

// @constants
const {
    BROKER_MIFID_PRODUCTS_FETCH,
    BROKER_MIFID_PRODUCTS_FETCH_SUCCESS,
    BROKER_MIFID_PRODUCTS_FETCH_FAILURE
} = require('constants/actionTypes');

const successFetch = (productId, response) => {
    return {
        type: BROKER_MIFID_PRODUCTS_FETCH_SUCCESS,
        payload: {
            productId,
            response
        }
    };
};

const failureFetch = (productId, error) => {
    return {
        type: BROKER_MIFID_PRODUCTS_FETCH_FAILURE,
        payload: {
            productId,
            error
        }
    };
}

/**
 * @param {String} productId
 */
const fetchMiFIDProduct = (productId, history) => (dispatch) => {
    dispatch({
        type: BROKER_MIFID_PRODUCTS_FETCH,
        payload: {
            productId
        }
    });

    const url = apiURLBuilder.getURL('brokerMifidTestConveniencia');

    const requestData = {
        header: {
            version: 2
        },
        query:{
            idProducto: productId
        }
    };

    return APIGet(dispatch, url, requestData).then(
        (response) => dispatch(successFetch(productId, response)),
        (error) => {
            dispatch(failureFetch(productId, error));
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
    );
};

module.exports = {
    fetchMiFIDProduct
};
